import React from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FaCheckCircle } from "react-icons/fa";
import Section7Img from "./section7.png";
import img from "../../img/CWTA.webp";

const Section7 = ({ ComponentData, index }) => {
  // console.log("ComponentData:====>>", ComponentData);
  console.log("index:", index);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        // border: "1px solid red",
        backgroundColor: "#f5f5f7",
        height: "100%",
      }}
    >
      <Stack
        sx={{
          height: { xs: "100%", sm: "100%" },
          width: { xs: "100%", sm: "60%" },
          // border: "1px solid red",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <img src={img} alt="img" style={{ height: "80%", width: "80%" }} /> */}
        <img
          src={ComponentData[index]?.section7?.card_image}
          alt="img"
          style={{ height: "80%", width: "80%" }}
        />
      </Stack>
      <Stack
        sx={{
          height: "100%",
          width: { xs: "100%", sm: "35%" },
          // border: "1px solid blue",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack
          sx={{
            height: "auto",
            width: "100%",
            // border: "2px solid green",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Stack
            sx={{
              lineHeight: {
                lg: "48px",
                xl: "48px",
                md: "32px",
                xs: "24px",
                sm: "24px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "40px",
                xl: "40px",
                md: "28px",
                xs: "20px",
                sm: "20px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 600,
                xl: 600,
                xs: 600,
                sm: 600,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
            }}
          >
            {/* Unlock digital success for your business with all-in-one SaaS
            solution! */}
            {ComponentData[index]?.section7?.card_head1}
          </Stack>
          <Stack
            sx={{
              lineHeight: {
                lg: "32px",
                xl: "32px",
                md: "20px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "24px",
                xl: "24px",
                md: "16px",
                xs: "16px",
                sm: "16px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
              color: "rgb(0, 0, 0)",
              // paddingLeft: "12px",
              padding: "12px",
              // paddingRight: "12px",
              // border: "1px solid rgb(218 233 248)",
              borderRadius: "8px",
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "flex",
              },
            }}
          >
            {/* Seamlessly integrate with multiple apps and maximize your brand's
            digital potential. Drive data-driven growth and achieve unparalleled
            success with Vertex Suite */}
            {ComponentData[index]?.section7?.card_head2}
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              padding: "12px",
            }}
          >
            <Button
              variant="contained"
              size="medium"
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                // Initial background
                color: "white", // Text color
                backgroundColor: "rgb(5, 78, 146)",
                borderColor: "rgb(5, 78, 146)", // Border same as background
                boxShadow:
                  "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                "&:hover": {
                  backgroundColor: "rgb(31, 133, 192)", // Hover background
                  borderColor: "rgb(31, 133, 192)", // Hover border
                },
              }}
            >
              Schedule demo
            </Button>{" "}
            <Button
              variant="outlined"
              size="medium"
              sx={{
                textTransform: "none",
                borderRadius: "8px",

                color: "rgb(5, 78, 146)", // Text color
                borderColor: "rgb(5, 78, 146)", // Border same as background
                boxShadow:
                  "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                "&:hover": {
                  borderColor: "rgb(31, 133, 192)", // Hover border
                },
              }}
            >
              Login
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Section7;
